import axios from 'axios';

/**
 * List all agents with merged configs (summary for list view).
 */
export async function getAgents() {
  const response = await axios.get('/admin/agents');
  return response.data;
}

/**
 * Get full agent config (merged default + override).
 */
export async function getAgent(agentId) {
  const response = await axios.get(`/admin/agents/${agentId}`);
  return response.data;
}

/**
 * Create or update agent config override.
 */
export async function updateAgent(agentId, data) {
  const response = await axios.put(`/admin/agents/${agentId}`, data);
  return response.data;
}

/**
 * Remove override, revert to static default.
 */
export async function resetAgent(agentId) {
  const response = await axios.delete(`/admin/agents/${agentId}/reset`);
  return response.data;
}

// ---- Knowledge Management (B4) ----

/**
 * Upload PDF/DOCX files to agent's vector store.
 * @param {string} agentId
 * @param {FileList|File[]} files
 * @param {Function} onProgress - axios onUploadProgress callback
 */
export async function uploadKnowledgeFiles(agentId, files, onProgress) {
  const formData = new FormData();
  for (const file of files) {
    formData.append('files', file);
  }
  const response = await axios.post(`/admin/agents/${agentId}/knowledge/upload`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: onProgress,
    timeout: 300000, // 5 min for large files + indexing
  });
  return response.data;
}

/**
 * Remove a file from agent's vector store.
 * @param {string} agentId
 * @param {string} fileId - vectorStoreFileId
 */
export async function removeKnowledgeFile(agentId, fileId) {
  const response = await axios.delete(`/admin/agents/${agentId}/knowledge/files/${fileId}`);
  return response.data;
}

/**
 * Migrate legacy vector store to DB-managed.
 * @param {string} agentId
 */
export async function migrateKnowledge(agentId) {
  const response = await axios.post(`/admin/agents/${agentId}/knowledge/migrate`);
  return response.data;
}

// ---- B5B: Create / Duplicate / Delete ----

/**
 * Create a new dynamic GenIA.
 */
export async function createAgent(data) {
  const response = await axios.post('/admin/agents', data);
  return response.data;
}

/**
 * Duplicate an existing GenIA as a new dynamic agent.
 */
export async function duplicateAgent(agentId) {
  const response = await axios.post(`/admin/agents/${agentId}/duplicate`);
  return response.data;
}

/**
 * Permanently delete an agent (dynamic: disappears; native: reverts to default).
 */
export async function deleteAgent(agentId) {
  const response = await axios.delete(`/admin/agents/${agentId}`);
  return response.data;
}
